import React from 'react'
import ActiveServiceTxnPanel from './ActiveServiceTxnPanel'
import CheckedoutServiceTxnPanel from './CheckedoutServiceTxnPanel'

export default class StationReportTabContainer extends React.Component {
  state = {
    activeTab: 'tab1',
    refresh: {
      tab1: false,
      tab2: false,
    },
  }

  refreshTab = (key) => {
    this.setState({
      ...this.state,
      refresh: {
        ...this.state.refresh,
        [key]: true,
      },
    })
  }

  createRefreshTabCompleteHandler = (key) => () => {
    this.setState({
      ...this.state,
      refresh: {
        ...this.state.refresh,
        [key]: false,
      },
    })
  }

  handleSelect = (key) => {
    this.setState({
      activeTab: key,
      refresh: {
        ...this.state.refresh,
        [key]: true,
      },
    })
  }

  render() {
    const { activeTab } = this.state

    return (
      <div className="w-full">
        {/* Tab Navigation */}
        <div className="border-b border-gray-200 mb-6">
          <div className="flex space-x-1">
            <button
              onClick={() => this.handleSelect('tab1')}
              className={`px-6 py-3 font-medium text-sm transition-all duration-200 border-b-2 ${
                activeTab === 'tab1'
                  ? 'border-primary-600 text-primary-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              Active Check-in
            </button>
            <button
              onClick={() => this.handleSelect('tab2')}
              className={`px-6 py-3 font-medium text-sm transition-all duration-200 border-b-2 ${
                activeTab === 'tab2'
                  ? 'border-primary-600 text-primary-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              Checked out
            </button>
          </div>
        </div>

        {/* Tab Content */}
        <div className="w-full md:px-6">
          {activeTab === 'tab1' && (
            <ActiveServiceTxnPanel
              isRefresh={this.state.refresh.tab1}
              onRefreshTabComplete={this.createRefreshTabCompleteHandler(
                'tab1',
              )}
            />
          )}
          {activeTab === 'tab2' && (
            <CheckedoutServiceTxnPanel
              isRefresh={this.state.refresh.tab2}
              onRefreshTabComplete={this.createRefreshTabCompleteHandler(
                'tab2',
              )}
            />
          )}
        </div>
      </div>
    )
  }
}
